import Vue from 'vue'
import App from './App.vue'
import store from '@/store'
import router from '@/router'
import VueGtm from '@gtm-support/vue2-gtm'
import Vuelidate from 'vuelidate'
import VueTour from 'vue-tour'
import './registerServiceWorker'
import firebaseService from '@/services/firebaseService'
import authService from '@/services/authService'

require('vue-tour/dist/vue-tour.css')

const isSupported = 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window
if (isSupported) {
  Notification.requestPermission().then(function(permission) { console.log('permiss', permission) })
  firebaseService.getMessageNotification()
}

authService.getCsrfToken()

Vue.config.productionTip = false

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  queryParams: {},
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '', // Will add `nonce` to the script tag
  enabled: process.env.VUE_APP_GTM_ENABLED === 'true', // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: process.env.VUE_APP_GTM_DEBUG === 'true', // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
})

Vue.use(VueTour)

new Vue({
  store,
  router,
  Vuelidate,
  render: h => h(App)
}).$mount('#app')
